import {GET_GL_ACCOUNT_NOTES} from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';

export default function notesReducer(state = initialstate.glNotes, action) {
	switch (action.type) {
		case GET_GL_ACCOUNT_NOTES:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return state;
		default:
			return state;
	}
}
